import { render, staticRenderFns } from "./ContactCTA.vue?vue&type=template&id=1f8a0a32&scoped=true&"
import script from "./ContactCTA.vue?vue&type=script&lang=js&"
export * from "./ContactCTA.vue?vue&type=script&lang=js&"
import style0 from "./ContactCTA.vue?vue&type=style&index=0&id=1f8a0a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a0a32",
  null
  
)

export default component.exports